export default "/images/7cfa5094e11948cded4643676a36562c.avif";